import React from "react";
import Banner from "../../Components/Banner";
import Footer from "../../Components/Footer";
import { motion } from "framer-motion";
import CaseStudyInitialSection from "./Sections/CaseStudyInitial/CaseStudyInitial";
import WorkedOnSection from "../../Components/WorkedOnSection";
import Header from "../../Components/Header";
import GradientGlowDivider from "../../Components/GradientGlowDivider";
import { useParams, useNavigate } from "react-router-dom";
import { caseStudiesData } from "../../Data";
import { useEffect } from "react";

const CaseStudyPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const caseStudy = caseStudiesData.find((item) => item.id === parseInt(id));

  useEffect(() => {
    if (!caseStudy) {
      // Redirect if ID is not valid
      navigate("/");
    }
  }, [caseStudy, navigate]);

  // Optional: Don't render anything if card is invalid
  if (!caseStudy) return null;

  return (
    <motion.div
      className="flex flex-col"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <div className="sticky md:static top-0 md:top-auto z-50 md:z-0 bg-app-background md:bg-transparent">
        <Header />
        <div className="w-[90%] mx-auto hidden md:block">
          <GradientGlowDivider />
        </div>
      </div>

      {caseStudy ? (
        <>
          <CaseStudyInitialSection data={caseStudy} />
          <WorkedOnSection className="!mt-0 !pb-10 md:pb-48 mb-20 md:mb-0" />
        </>
      ) : (
        <h1>No Data Found</h1>
      )}

      <Banner title="Want to work with us?" subtitle="Let's Talk!" />
      <Footer />
    </motion.div>
  );
};

export default CaseStudyPage;
